import { styled } from '@mui/material/styles';

export const CommentColumnStyled = styled('a', { name: 'CommentColumnStyled' })(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: 'underline',
  cursor: 'pointer',
  display: 'block',
  minHeight: '10px',
}));
